const AuditApplicationForm = (data, review) => {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;

    const formattedToday = dd + "/" + mm + "/" + yyyy;

    const mappedReviews = review.map(review => ({
        reviewQuestion: review.reviewQuestion,
        reviewAnswer: review.reviewAnswer ? 'yes' : 'no'
    }));

    const tableRows = mappedReviews.map((row, index) => `
    <tr>
        <td colspan="5">${row.reviewQuestion}</td>
        <td>${row.reviewAnswer}</td>
`
    ).join('');


    return `
    <!DOCTYPE html>
    <html lang="en">

    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Document</title>
    </head>
    <style>
        table,
        th,
        td {
            border: 1px solid black;
            border-collapse: collapse;
            padding: 15px;
            font-size: 12px;
        }
    </style>

    <body>
        <table style="width: 60%">
            <tr>
                <th rowspan="2"><img
                    width="60"
                    height="60"
                    src="data:image/jpg;base64,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"
                /></th>
                <th rowspan="2" colspan="3">Eat right scheme audit Application form</th>
                <th>format</th>
                <th>caussa/f-16</th>
            </tr>
            <tr>
                <th>Date</th>
                <th>${formattedToday}</th>
            </tr>

            <tr>
                <th>C.Code</th>
                <td colspan="5">${data.CCOde}</td>
            </tr>

            <tr>
                <th>Name as per FSSAI</th>
                <td colspan="5">${data.CompanyName}</td>
            </tr>

            <tr>
                <th colspan="6">Address</th>
            </tr>

            <tr>
                <th>Door No</th>
                <td colspan="5">${data?.DoorNo}</td>
            </tr>
            <tr>
                <th>Street Name</th>
                <td colspan="5">${data?.StreetName}</td>
            </tr>
            <tr>
                <th>Area / Village</th>
                <td colspan="5">${data.City}</td>
            </tr>
            <tr>
                <th>District</th>
                <td colspan="5">${data.District}</td>
            </tr>
            <tr>
                <th>Pincode</th>
                <td colspan="5">${data.PinCode}</td>
            </tr>

            <tr>
                <th>Contact No</th>
                <td colspan="2">${data.ContactNo}</td>
                <th>contact person</th>
                <td colspan="2">${data.ContactPerson}</td>
            </tr>

            <tr>
                <th>Main production/service</th>
                <td colspan="5">${data.MainProductionOrService || data.typeOfServices}</td>
            </tr>
            <tr>
                <th>Audit type</th>
                <td colspan="5">${data.AuditType}</td>
            </tr>

            <tr>
                <th>Kind of Business</th>
                <td colspan="2">${data.typeOfServices}</td>
                <th>No of Food handlers</th>
                <td colspan="2">${data.FoodHandlers}</td>
            </tr>

            <tr>
                <th>Name of FoSTac trained food safety supervisor</th>
                <td colspan="2">${data.Supervisors}</td>
                <th>Unique certificate number and course name</th>
                <td colspan="2">${data.uniqueCertificateNo} / ${data.courseCode}</td>
            </tr>

            <tr>
                <th>FSSAI LICENSE NUMBER</th>
                <td colspan="2">${data.FSSAI_LicenseNumber}</td>
                <th rowspan="2">Authorisecd Signatory of food service establishment</th>
                <td rowspan="2" colspan="2"></td>
            </tr>

            <tr>
                <th>VALIDITY OF LICENSE</th>
                <td colspan="2">${data.validityOfLicense}</td>
            </tr>

            <tr>
                <th colspan="4">For Accounting</th>
                <th>GST NO</th>
                <td>${data.GST}</td>
            </tr>

            <tr>
                <th>Contact Person</th>
                <td>${data.ContactPerson}</td>
                <th>Email Id</th>
                <td>${data.Email}</td>
                <th>Contact Number</th>
                <td>${data.ContactNo}</td>
            </tr>

            <tr>
                <th colspan="5">Review - For office use only</th>
            </tr>

            <tbody id="audit-questions-body">
                        ${tableRows}
            </tbody>
           

            <tr>
                <th rowspan="2">Remarks</th>
                <td rowspan="2" colspan="2">${data.Remarks}</td>
                <th>signature</th>
                <td colspan="2"></td>
            </tr>

            <tr>
                <th>Date</th>
                <td colspan="2">${formattedToday}</td>
            </tr>
        </table>
    </body>

</html>`
}

export default AuditApplicationForm;